import ExtendedError from './type/Extended';

type T = (status: number, message: string) => void;

const f: T = (status, message) => {
    const error = new Error(message) as ExtendedError;
    error.status = status;

    throw error;
};

export default f;
